var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mayor-map"},[_c('div',{ref:"map",staticClass:"mayor-map__map"})])}
var staticRenderFns = []

export { render, staticRenderFns }